/**
 * Notice Component
 *
 * Standard inline notice used across admin pages.
 * Variants: success | warning | error | info
 *
 * @package MultilingualPressZone
 */

import { el } from '../utils/dom.js';

const VARIANT_TO_ICON = {
    success: '✓',
    warning: '⚠️',
    error: '⨯',
    info: 'i',
};

/**
 * Render a notice.
 *
 * @param {Object} options
 * @param {string} options.message
 * @param {('success'|'warning'|'error'|'info')} [options.variant='info']
 * @param {boolean} [options.alert=false] - Adds role="alert"
 * @param {string} [options.icon] - Override icon
 * @param {string} [options.className]
 * @return {HTMLElement}
 */
export function Notice({
    message,
    variant = 'info',
    alert = false,
    icon,
    className = ''
} = {}) {
    const safeVariant = VARIANT_TO_ICON[variant] ? variant : 'info';
    const iconText = typeof icon === 'string' && icon !== '' ? icon : VARIANT_TO_ICON[safeVariant];

    return el('div', {
        class: ['mpz-notice', `mpz-notice--${safeVariant}`, className].filter(Boolean).join(' '),
        role: alert ? 'alert' : undefined
    },
        el('span', { class: 'mpz-notice__icon', 'aria-hidden': 'true' }, iconText),
        el('span', { class: 'mpz-notice__text' }, String(message || ''))
    );
}

export default Notice;
